import type { ReactElement } from 'react';
import { translate, TranslateOptionsParams, TranslateOptionsWithTemplatesParams } from '@fiverr-private/i18n-react';
import copies from '../../copies.json';

type Copies = typeof copies;

type DeepKeysOf<T, Key extends keyof T = keyof T> = Key extends string
    ? T[Key] extends Record<'one' | 'other', string>
        ? Key
        : T[Key] extends Record<string, any>
        ? `${Key}.${DeepKeysOf<T[Key]>}`
        : Key | (T[Key] extends string ? `${Key}.${T[Key]}` : never)
    : never;

type TranslationKey = DeepKeysOf<Copies>;

type ExtractAfterDot<T> = T extends `reselling_listings_perseus.${infer Rest}` ? Rest : never;

export type TranslationKeyWithPrefix = ExtractAfterDot<TranslationKey>;

export function appTranslate<T extends string | ReactElement = string>(
    key: ExtractAfterDot<TranslationKey>,
    options?: TranslateOptionsParams
): T;

export function appTranslate<T extends string | ReactElement = ReactElement>(
    key: ExtractAfterDot<TranslationKey>,
    options: TranslateOptionsWithTemplatesParams
): T;

export function appTranslate(
    key: ExtractAfterDot<TranslationKey>,
    options?: TranslateOptionsParams | TranslateOptionsWithTemplatesParams
) {
    return translate(`reselling_listings_perseus.${key}`, options);
}

export const countriesTranslate = (
    key: string,
    options?: TranslateOptionsParams | TranslateOptionsWithTemplatesParams
) => translate(`countries.${key}`, options);
